export const API_URL = process.env.REACT_APP_API_URL;
export const DEFAULT_TIMEOUT = 8000;

export const IS_DEV = process.env.NODE_ENV !== 'production';



// WEBPACK FOOTER //
// ./src/config.js